<div #divParent class="expertise-wordcloud-container">
  <angular-tag-cloud
    [data]="data"
    [zoomOnHover]="wordCloudZoomOnHoverOptions"
    [width]="options.width"
    [height]="options.height"
    [overflow]="options.overflow"></angular-tag-cloud>
  <!--<img src="/assets/images/word-cloud.png"/>!-->
</div>
